import type { ThemeNames } from '@sravni/design-system-theme';

import { PARTNERS_CUSTOM_THEME } from './customTheme';
import { DefaultStylesWrapper } from './ui/DefaultStylesWrapper';

export const getStylesThemeByPartner = (affId: string | null | undefined, defaultTheme: ThemeNames) => {
    if (!affId) {
        return { themeName: defaultTheme, Component: DefaultStylesWrapper };
    }

    return (
        PARTNERS_CUSTOM_THEME[affId as keyof typeof PARTNERS_CUSTOM_THEME] ?? {
            themeName: defaultTheme,
            Component: DefaultStylesWrapper,
        }
    );
};
